"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  isPublishing: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, null, /*#__PURE__*/_react.default.createElement("p", {
  className: "text-danger"
}, "This competition has been cancelled"));
var _ref2 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This competition does not have any races yet.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Before it can be opened for entry, please check the set up data in the other tabs on this page, then generate the races on the races tab.");
var _ref4 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, " This competition is not visible to the paddlers"), /*#__PURE__*/_react.default.createElement("p", null, "Before it can be made visible to paddlers and used for entry,your club treasurer needs to confirm the club account details."), /*#__PURE__*/_react.default.createElement("p", null, " When this is complete return to this tab to action the competition."));
var _ref5 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This competition is not visible to the paddlers"), /*#__PURE__*/_react.default.createElement("p", null, " Check the setup of your competition and then click the button to publish the competition."), /*#__PURE__*/_react.default.createElement("p", null, "Online entries will not be permitted until the open date on your setup"));
class CompetitionStatus extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onErrorDismissed", () => {
      return this.setState(initialState);
    });
    _defineProperty(this, "_onPublishCompetition", () => {
      if (this.state.isPublishing) return;
      this.setState({
        isPublishing: true
      });
      return this.props.onPublishCompetition(this.props.competition.id).then(result => {
        if (result && !result.success) {
          this.setState({
            errorMessage: result.message
          });
          return this.setState({
            isPublishing: false
          });
        }
        return this.setState(initialState);
      });
    });
    _defineProperty(this, "_onHide", () => {
      this.props.onUpdateCompetition(this.props.competition.id, 'isPublished', false);
    });
  }
  render() {
    const competition = this.props.competition;
    return /*#__PURE__*/_react.default.createElement("div", null, !this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      buttons: /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this._onErrorDismissed
      }, "OK")
    }, /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.errorMessage)), !competition.isAdministratedByUser ? null : competition.isCancelled ? _ref : !competition.hasRaces ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, _ref2, _ref3, /*#__PURE__*/_react.default.createElement("p", null, 'When the races have been checked ' + (!competition.hasStripeSetupForClub ? 'and your treasurer has confirmed your club account details. ' : '') + 'then you can return to this tab to make your competition visible to paddlers.')) : !competition.hasStripeSetupForClub ? _ref4 : !competition.isPublished ? /*#__PURE__*/_react.default.createElement("div", null, _ref5, /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "publish-competition",
      type: "primary",
      onClick: this._onPublishCompetition,
      block: true
    }, "Publish the Competition")) : /*#__PURE__*/_react.default.createElement(_button.default, {
      "data-test-id": "hide-competition",
      onClick: this._onHide
    }, "Hide Competition from Paddlers"));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CompetitionStatus, "partialQueries", {
  Competition: {
    id: true,
    isAdministratedByUser: true,
    isCancelled: true,
    hasRaces: true,
    hasStripeSetupForClub: true,
    isPublished: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(CompetitionStatus, undefined, (client, props) => ({
  onPublishCompetition(competitionID) {
    return client.update('Competition.publishCompetition', {
      competitionID
    });
  },
  onUpdateCompetition(id, field, value) {
    return client.update('Competition.set', {
      id,
      field,
      value
    });
  }
}));